import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-address",
  "use": "icon-address-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-address\"><defs><style>#icon-address .cls-1{fill:currentColor;}</style></defs><path class=\"cls-1\" d=\"M8,3.35a2.81,2.81,0,1,1-2.81,2.8A2.8,2.8,0,0,1,8,3.35Zm6.16,2.81a6.16,6.16,0,0,0-12.32,0,6.09,6.09,0,0,0,1,3.36l4.61,6.14a.63.63,0,0,0,.83.28.73.73,0,0,0,.27-.28l4.62-6.14a6.22,6.22,0,0,0,1-3.36Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol